// Backend calls the wizard makes directly (not through Redux: none of this
// is shared state, and going through the Clients/Units slices would clobber
// the lists other pages are showing).
import { apiClient as api } from "../../../helpers/api_helper";
import { http } from "../../../helpers/api/http";
import { contractAPI } from "../../../helpers/api/contracts";
import { exchangeAPI } from "../../../helpers/api/exchange";

export const wizardAPI = {
  // POST /api/contracts/v2/extract-contract/ (multipart "file") — Claude on
  // Bedrock -> { data, contract_inconsistency, sections_missing, meta }.
  // Through `http` (not api_helper) because its errors keep the backend's
  // plain-string `error` message ("scanned PDF, needs OCR", "Bedrock
  // unreachable", ...), which the wizard shows as is.
  extract: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.postFormData("/contracts/v2/extract-contract/", fd);
  },

  // Projects come with their phases and each phase's blocks nested.
  projects: () => api.get("/projects/", { params: { active: true } }),

  // Every unit in a block (all=true -> plain array, no pagination). Filtered
  // client-side: a block is at most a few hundred units.
  unitsInBlock: (blockId) => api.get("/units/", { params: { block: blockId, all: true } }),

  unit: (id) => api.get(`/units/${id}/`),

  client: (id) => api.get(`/clients/${id}`),

  checkPvc: (pvc, year) => contractAPI.checkPvcNumber(pvc, year),

  exchangeRate: () => exchangeAPI.getExchangeRate(),

  createContract: (payload) => api.create("/contracts/", payload),

  // Attach the imported file to the new contract as its CONTRACT document.
  attachDocument: (contractId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("contract", contractId);
    fd.append("document_type", "CONTRACT");
    return api.createFormData("/documents/", fd);
  },
};
